import { API } from "api";
import React, { useEffect, useRef, useState } from "react";
import { UTILS } from "utils";
import PageHeading from "../../../components/PageHeading";
import AddAdminUser from "../component/AddAdminUser";
import ManageAdminUsers from "../component/ManageAdminUsers";
import { CONSTANTS as C } from "config";
import { useTranslation } from "react-i18next";
import AppContainer from "components/ui/AppContainer";
import AppButton from "components/ui/AppButton";
const CreateAdmin = () => {
  const [users, setUsers] = useState([]);
  const addUserSubmitRef = useRef(null);

  const { t } = useTranslation();
  const getAdminUsersByBrand = async () => {
    const userDetail = UTILS.getCurrentUser();

    const result = await API.GET_USERS_BY_BRAND({
      brandId: userDetail.brandId,
      token: userDetail.token,
      language: "EN",
    });

    if (UTILS.isValidObject(["data", "users"], result) && result.success === 1)
      setUsers(result.data.users);
    else {
    }
  };

  useEffect(() => {
    getAdminUsersByBrand();
  }, []);

  const handleValues = () => {
    getAdminUsersByBrand();
  };

  return (
    <AppContainer title={t("Users")} subTitle={t("You can add new users and set their acccess level, which will decide the stores they can utilize.")} containerProps={{
      style: {
        overflowY: "auto",
      }
    }}
    footer={
      <div className="flex">
        <AppButton
          size="lg"
          className="w-36"
          onClick={() => addUserSubmitRef.current?.()}
        >
          {t("Add User")}
        </AppButton>
      </div>
    }>
      <div className="flex justify-between flex-wrap min-h-0">
        <div className="w-full lg:w-6/12 lg:pr-3 lg:border-r lg:border-gray-200 lg:max-h-full lg:overflow-y-auto min-h-0">
          <AddAdminUser callback={handleValues} submitRef={addUserSubmitRef} />
        </div>
        <div className="w-full lg:w-6/12">
          <ManageAdminUsers users={users} onUsersChange={getAdminUsersByBrand} />
        </div>
      </div>
    </AppContainer>
  );
};
export default CreateAdmin;
